import { LoginService } from "@/services/login/LoginService";
import { SessionService } from "@/services/login/SessionService.js"

export var loginService = new LoginService();
export var sessionService = new SessionService();